import { useDispatch } from "react-redux";
import { useApi } from "store/modules/common";

import { useSelectorEq } from "commons/store/common";
import type { IState } from "store/modules";

import { PopupType } from "../../PopupType";
import { useAlert } from "../../popupHook";
import { rdxPopupOpen } from "commons/popup/store/popupR";
import { CalCompanyDataDownPopupFooter } from "./DataDownPopup";
import { apiGprofitDownloadExcel } from "pages/profit/store/ProfitR";

export const useCalculateCompanyDataPopup = () => {
  const dispatch = useDispatch();

  const popupOpen = async () => {
    dispatch(
      rdxPopupOpen({
        type: PopupType.CAL_COMPANY_DETAIL_POPUP,
        width: 420,
        buttonWrapper: CalCompanyDataDownPopupFooter,
      }),
    );
  };

  return { popupOpen };
};

export const useDataDownload = () => {
  const { apiResult } = useApi();
  const alert = useAlert();
  const { year_start, month_start, year_end, month_end } = useSelectorEq((state: IState) => ({
    year_start: state.ui.selectbox?.["calculate_company_popup_data_year_start"],
    month_start: state.ui.selectbox?.["calculate_company_popup_data_month_start"],
    year_end: state.ui.selectbox?.["calculate_company_popup_data_year_end"],
    month_end: state.ui.selectbox?.["calculate_company_popup_data_month_end"],
  }));

  const download = async () => {
    if (year_start === undefined) {
      alert("시작기간 년도를 선택해주세요.");
      return;
    }
    if (month_start === undefined) {
      alert("시작기간 월을 선택해주세요.");
      return;
    }
    if (year_end === undefined) {
      alert("종료기간 년도를 선택해주세요.");
      return;
    }
    if (month_end === undefined) {
      alert("종료기간 월을 선택해주세요.");
      return;
    }

    if (year_start && month_start && year_end && month_end) {
      await apiResult(apiGprofitDownloadExcel);
    }
  };
  return { download };
};
